<template src="../templates/normal_fcont_193.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'
import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import AppDownloadiPrint from '../components/AppDownloadiPrint'
import AppDownloadSmartPanel from '../components/AppDownloadSmartPanel'
import FuncSearchGalleryTop from '../components/FuncSearchGalleryTop'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '193',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage,Carousel,Slide,FuncSearchRecommendLink,InfoMachineTranslation,
    FuncSearchGalleryQR,ReleaseDateForArticle,AppDownloadiPrint,AppDownloadSmartPanel,FuncSearchGalleryTop
  },
  methods: {
    clickLink201: function() {
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "article_link_more",
        "custom_parameter2": "201"
      })
      
      this.$router.push({ 
        path: '/' + this.lg2 + '/articles/201',
        query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale }
      })
    },
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['193-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['193-3']}
    ]};

  }
};
</script>
<style scoped>
.onigiriaction_img {
    width: 720px;
    max-width: 100%;
    padding: 10px;
    background-color: white;
}

.subtitle {
    margin-top: 20px;
}

.campaign_detail {
  margin-top: 25px;
}

/* 他記事へのリンク */
.flex {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
}

.flex::before{ 
    display: none;
}

.flex .col {
    padding-bottom: 20px;
}

.func-search-recommend-link, .thumbnail {
    height: 100%;
    margin-bottom: 0px;
}

@media (max-width: 767px) {
    /* 他記事へのリンク */
  .flex .col {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
  }
}
</style>

